import React, { useState, useEffect } from 'react';
import {
  Container,
  Stack,
  Text,
  Card,
  Group,
  ThemeIcon,
  Progress,
  Badge,
  Loader,
  Center
} from '@mantine/core';
import {
  IconUsers,
  IconTrophy,
  IconClock
} from '@tabler/icons-react';
import { SalaMultijugadorResponseDTO } from '../../types/multijugador';

interface EsperandoResultadosProps {
  sala: SalaMultijugadorResponseDTO;
  participantesTerminados: number;
  totalParticipantes: number;
}

const EsperandoResultados: React.FC<EsperandoResultadosProps> = ({
  sala,
  participantesTerminados,
  totalParticipantes
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const progreso = (participantesTerminados / totalParticipantes) * 100;

  return (
    <Container size="sm" py="xl">
      <Stack gap="xl" align="center">
        {/* Icono principal */}
        <ThemeIcon size={120} radius="xl" variant="light" color="blue">
          <IconUsers size={60} />
        </ThemeIcon>

        {/* Título */}
        <Stack gap="xs" align="center">
          <Text size="2rem" fw={700} ta="center" className="text-blue-600">
            ¡Examen Completado!
          </Text>
          <Text size="lg" color="dimmed" ta="center">
            Esperando a los otros jugadores{dots}
          </Text>
        </Stack>

        {/* Card de información */}
        <Card withBorder padding="xl" radius="lg" className="w-full max-w-md">
          <Stack gap="lg">
            {/* Nombre de la sala */}
            <Group justify="center">
              <ThemeIcon size="md" radius="md" variant="light" color="indigo">
                <IconTrophy size={18} />
              </ThemeIcon>
              <Text fw={600} size="lg">
                {sala.nombreSala}
              </Text>
            </Group>

            {/* Progreso */}
            <Stack gap="sm">
              <Group justify="space-between">
                <Text size="sm" fw={500}>
                  Progreso del examen
                </Text>
                <Badge variant="light" color="blue">
                  {participantesTerminados}/{totalParticipantes}
                </Badge>
              </Group>

              <Progress
                value={progreso}
                size="xl"
                radius="xl"
                animated
                color="blue"
              />

              <Text size="xs" color="dimmed" ta="center">
                {participantesTerminados} de {totalParticipantes} participantes han terminado
              </Text>
            </Stack>

            {/* Mensaje de espera */}
            <Card withBorder padding="md" radius="md" className="bg-blue-50">
              <Group gap="sm">
                <ThemeIcon size="sm" radius="xl" variant="light" color="blue">
                  <IconClock size={16} />
                </ThemeIcon>
                <Text size="sm" color="dimmed">
                  Los resultados se mostrarán cuando todos terminen
                </Text>
              </Group>
            </Card>

            {/* Loader */}
            <Center>
              <Loader size="sm" color="blue" />
            </Center>
          </Stack>
        </Card>

        {/* Texto adicional */}
        <Text size="sm" color="dimmed" ta="center" className="max-w-md">
          Mientras esperas, los demás participantes están completando su examen.
          Serás redirigido automáticamente al podium cuando todos finalicen.
        </Text>
      </Stack>
    </Container>
  );
};

export default EsperandoResultados;
